import gql from 'graphql-tag';
//agregar fecha de vigencia para apis
export const queryCliente = gql`
   query Cliente($codigoCliente: String!) {
      llavesNoAnuladas(codigo: $codigoCliente) {
         codigo
         ruc
         razonSocial
         iter
         usuario
         documento
         anio
         fechaExpiracion
         fechaVigenciaApi
         producto
         modular
         ide
         mac
         cpu
         placa
         bios
         sisoper
         ram
         chip
      }
   }
`;

export const mutationReset = gql`
   mutation ResetearLlaves($codigos: String!, $usuario: String!, $razon: String!) {
      resetearLlaves(codigos: $codigos, usuario: $usuario, razon: $razon) {
         msg
      }
   }
`;

export const mutationBaja = gql`
   mutation DarBajaLlaves($codigos: String!, $usuario: String!, $razon: String!) {
      darBajaLlaves(codigos: $codigos, usuario: $usuario, razon: $razon) {
         msg
      }
   }
`;
